<template>
  <div>
    <b-modal
        scrollable
      id="add-article-direct-existing-editing"
      ref="modal"
      header-class="headerModal"
      centered
      :title="`${$t('AddArticle')}`"
      hide-footer
      @hide="onCancel"
    >
      <b-form-group
        :label="$t('Name')"
      >
        <b-form-input
          v-model="name"
          :placeholder="$t('Name')"
        />
        <p
          v-if="buttonSubmited && !name"
          style="color:red;"
        >
          {{ $t('This_is_a_required_field') }}
        </p>
      </b-form-group>
      <b-form-group
        :label="$t('Category')"
      >
        <vue-select
          v-model="selectedCategory"
          :options="optionsCategory"
          label="nameFiltering"
          :reduce="(e) => e.lovDressCategoryId"
          :placeholder="$t('Category')"
          aria-describedby="input-1-live-feedback"
          :clearable="false"
        />
      </b-form-group>
      <div class="buttonsEverywhere">
        <b-button
          type="button"
          variant="none"
          class="buttonSubmit"
          style="background: #FF274F !important;"

          @click="onSubmit"
        >
          {{ $t('Submit') }}
        </b-button>
        <b-button
          type="button"
          variant="danger"
          class="buttonCancel"
          style="margin-right: 15px; ; background: white; color: black; border-color: white;font-weight: 400;"

          @click="onCancel"
        >
          {{ $t('Cancel') }}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      name: null,
      selectedCategory: null,
      buttonSubmited: false,
    }
  },
  computed: {
    ...mapGetters(['getDressCategory']),
    optionsCategory() {
      const valoniCategory = this.getDressCategory.map((category) => {
        return {
          name: category.name,
          nameFiltering: category.name,
          lovDressCategoryId: category.lovDressCategoryId,
        }
      });
      const nullCategory = {
        name: null,
        nameFiltering: 'All',
        lovDressCategoryId: null,
      }
      const combinedCategories = [nullCategory, ...valoniCategory];

      return combinedCategories;
    },
  },
  mounted() {

  },
  methods: {
    ...mapActions([]),
    onSubmit() {
      this.buttonSubmited = true
      if (!this.name && this.buttonSubmited) {
        return
      }
      const object = {
        name: this.name,
        lovDressCategoryId: this.selectedCategory,
      }
      this.$emit('addArticle', object)
      this.onReset()
    },
    onCancel() {
      this.onReset()
    },
    onReset() {
      this.name = null
      this.selectedCategory = null
      this.buttonSubmited = false
      this.$refs.modal.hide()
    },
  },
}
</script>

      <style lang="scss" scoped>

      </style>
